import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import "./pd-history-item.js";
import { LitElement, css, html } from "lit";
import { property } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import { repeat } from "lit/directives/repeat.js";
//#region src/pd-history/PdHistoryList.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
var PdHistoryList = class PdHistoryList extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.entries = [];
		this.loading = false;
	}
	static {
		this.styles = css`
    :host {
      display: block;
      container-type: inline-size;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      padding: var(--pd-history-row-gap, 0) 0;
    }

    li + li {
      border-top: 1px solid
        var(--pd-history-separator-col, var(--pd-default-light-col, #e0e0e0));
    }

    .empty {
      color: var(--pd-default-font-muted-col, #757575);
      font-style: italic;
      padding: 0.6rem 0;
    }

    .skeleton {
      height: 3rem;
      margin: 0.6rem 0;
      border-radius: 4px;
      background: var(--pd-default-bg-light-col, #eee);
      animation: pulse 1.5s ease-in-out infinite;
    }

    @keyframes pulse {
      50% {
        opacity: 0.5;
      }
    }
  `;
	}
	render() {
		return html`
      <div class="head"><slot name="head"></slot></div>
      ${this.loading ? this._renderLoading() : this._renderList()}
    `;
	}
	/**
	* Filter hook for the upcoming search/kind-filter extension —
	* the render list always runs through this step.
	*/
	get _visibleEntries() {
		return this.entries;
	}
	_renderLoading() {
		return html`
      <div
        role="status"
        aria-label="${msg("Historie wird geladen", { id: "pd.history.list.loading" })}"
      >
        <div class="skeleton"></div>
        <div class="skeleton"></div>
        <div class="skeleton"></div>
      </div>
    `;
	}
	_renderList() {
		const entries = this._visibleEntries;
		if (entries.length === 0) return html`
        <div class="empty">
          ${this.emptyText ?? msg("Noch keine Einträge", { id: "pd.history.list.empty" })}
        </div>
      `;
		return html`
      <ul role="list">
        ${repeat(entries, (entry) => entry.id, (entry) => html`
            <li>
              <pd-history-item
                .entry="${entry}"
                .actionLabels="${this.actionLabels}"
                .fieldLabels="${this.fieldLabels}"
                .appLabels="${this.appLabels}"
                .valueFormatter="${this.valueFormatter}"
              ></pd-history-item>
            </li>
          `)}
      </ul>
    `;
	}
};
__decorate([property({ attribute: false })], PdHistoryList.prototype, "entries", void 0);
__decorate([property({ type: Boolean })], PdHistoryList.prototype, "loading", void 0);
__decorate([property({ attribute: false })], PdHistoryList.prototype, "actionLabels", void 0);
__decorate([property({ attribute: false })], PdHistoryList.prototype, "fieldLabels", void 0);
__decorate([property({ attribute: false })], PdHistoryList.prototype, "appLabels", void 0);
__decorate([property({ attribute: false })], PdHistoryList.prototype, "valueFormatter", void 0);
__decorate([property()], PdHistoryList.prototype, "emptyText", void 0);
PdHistoryList = __decorate([localized()], PdHistoryList);
//#endregion
export { PdHistoryList };
